"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var MasspayWithdrawalMethodType;
(function (MasspayWithdrawalMethodType) {
    MasspayWithdrawalMethodType["CASH_PICKUP"] = "CASH_PICKUP";
    MasspayWithdrawalMethodType["BANK_DEPOSIT"] = "BANK_DEPOSIT";
    MasspayWithdrawalMethodType["HOME_DELIVERY"] = "HOME_DELIVERY";
    MasspayWithdrawalMethodType["MOBILE_WALLET"] = "MOBILE_WALLET";
    MasspayWithdrawalMethodType["MASSPAY_CARD"] = "MASSPAY_CARD";
    MasspayWithdrawalMethodType["PAPER_CHECK"] = "PAPER_CHECK";
    MasspayWithdrawalMethodType["BILL"] = "BILL";
    MasspayWithdrawalMethodType["CRYPTOCURRENCY"] = "CRYPTOCURRENCY";
})(MasspayWithdrawalMethodType = exports.MasspayWithdrawalMethodType || (exports.MasspayWithdrawalMethodType = {}));
class PayeeInformationProvider extends DataProvider_1.default {
    get fragments() {
        return {
            PayeeInformation: () => `
        ... on PayeeInformation {
          userId
          payoutSystem
          firstName
          lastName
          address
          city
          country
          currency
          phone
          state
          zip
          other {
            details
          }
          paxum {
            account
          }
          paypal {
            account
          }
          bank {
            nameOnAccount
            bankName
            bankAddress
            bankAccountNumber
            bankRouting
            accountDetails
          }
          masspay {
            fields
            attrSetToken
            destinationToken
          }
        }`,
            MasspayMethod: () => `
        ... on MasspayMethod {
          name
          type
          currencies
          destinationToken
        }`,
            MasspayField: () => `
        ... on MasspayField {
          token
          attrSetToken
          label
          validation
          isOptional
          value
          expectedValue
          type
          inputType
          lastAttrValueUsed
        }`,
            MasspayPrePayoutInfo: () => `
        ... on MasspayPrePayoutInfo {
          fee
        }`,
        };
    }
    find({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query PayeeInformationFind($id: ID!) {
          payeeInformation(id: $id) {
            ${this.getFragment("PayeeInformation")}
          }
        }
      `,
                variables: { id },
            });
            return resp.data.payeeInformation;
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation PayeeInformation($data: inputPayeeInformation!) {
          payeeInformation(data: $data) {
            ${this.getFragment("PayeeInformation")}
          }
        }
      `,
                variables: { data },
            });
            return resp.data.payeeInformation;
        });
    }
    getMasspayMethods({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation masspayMethodsSearch($data: InputMasspayMethodsSearch!) {
          masspayMethodsSearch(data: $data) {
            ${this.getFragment("MasspayMethod")}
          }
        }
      `,
                variables: { data },
            });
            return resp.data.masspayMethodsSearch;
        });
    }
    getMasspayFields({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation MasspayFieldsSearch($data: InputMasspayFieldsSearch!) {
          masspayFieldsSearch(data: $data) {
            ${this.getFragment("MasspayField")}
          }
        }
      `,
                variables: { data },
            });
            return resp.data.masspayFieldsSearch;
        });
    }
    getMasspayPrePayoutInfo({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("masspayGetPrePayoutInfo", { data }, this.getFragment("MasspayPrePayoutInfo"));
        });
    }
}
exports.PayeeInformationProvider = PayeeInformationProvider;
//# sourceMappingURL=PayeeInformationProvider.js.map